(() => {
  const HANDLE = 'custom-nfc-business-cards';
  const onProduct = () => location.pathname.split('/').filter(Boolean).includes(HANDLE);
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency:'GBP'}).format(value);
  function start(){
    if(!onProduct()) return;
    const marker=document.querySelector('input[name="properties[NFC destination URL]"]');
    const form=(marker && marker.closest('form')) || Array.from(document.querySelectorAll('form.product-form')).find(candidate => candidate.querySelector('.nfc-order-intro')) || document.querySelector('.product-form');
    if(!form || form.dataset.nfcPricingReady==='true') return;
    form.dataset.nfcPricingReady='true';

    const intro=form.querySelector('.nfc-order-intro');
    if(intro){
      const first=intro.querySelector('li');
      if(first) first.textContent='Order from 1 card — enter the exact quantity you need';
    }

    const panel=document.createElement('section');
    panel.className='nfc-pricing-panel';
    panel.setAttribute('aria-label','NFC business card volume pricing');
    panel.innerHTML='<p class="nfc-pricing-panel__eyebrow">Automatic volume pricing</p><h3>The more you order, the lower the price per card.</h3><div class="nfc-pricing-grid"><div class="nfc-pricing-tier"><strong>1–99 cards</strong><span>£1.00 each</span></div><div class="nfc-pricing-tier"><strong>100–249 cards</strong><span>£0.80 each</span></div><div class="nfc-pricing-tier nfc-pricing-tier--best"><strong>250+ cards</strong><span>£0.70 each</span></div></div><p class="nfc-free-delivery">FREE UK STANDARD DELIVERY · VOLUME PRICE APPLIED AUTOMATICALLY</p>';
    form.insertBefore(panel, form.firstChild);

    let qty=form.querySelector('input[name="quantity"]');
    if(!qty){ qty=document.createElement('input'); qty.name='quantity'; }
    qty.type='number'; qty.id='NfcCardQuantity'; qty.className='quantity-input nfc-card-quantity'; qty.min='1'; qty.step='1'; qty.inputMode='numeric'; qty.required=true;
    if(!Number(qty.value) || Number(qty.value)<1) qty.value='1';

    const oldNote=form.querySelector('.nfc-pack-note');
    const block=document.createElement('div');
    block.className='nfc-quantity-block';
    block.innerHTML='<label for="NfcCardQuantity">Number of cards <span aria-hidden="true">*</span></label><div class="nfc-live-summary" aria-live="polite"></div>';
    const summary=block.querySelector('.nfc-live-summary');
    block.insertBefore(qty, summary);
    if(oldNote){ oldNote.replaceWith(block); }
    else {
      const row=form.querySelector('.quantity-row');
      if(row) form.insertBefore(block,row); else form.append(block);
    }

    const render=()=>{
      let q=Math.max(1,Math.floor(Number(qty.value)||1));
      if(String(q)!==qty.value && document.activeElement!==qty) qty.value=String(q);
      const unit=q>=250?.70:q>=100?.80:1;
      const total=q*unit;
      const hint=q>=250?'Best price unlocked.':q>=100?`Add ${250-q} more card${250-q===1?'':'s'} to unlock £0.70 each.`:`Add ${100-q} more card${100-q===1?'':'s'} to unlock £0.80 each.`;
      summary.innerHTML=`<strong>${q} card${q===1?'':'s'} · ${money(unit)} each · ${money(total)} estimated product total</strong><p class="nfc-tier-hint">${hint}</p><p>Free UK standard delivery. Final automatic discount is shown in cart/checkout.</p>`;
    };
    qty.addEventListener('input',render);
    qty.addEventListener('change',()=>{qty.value=String(Math.max(1,Math.floor(Number(qty.value)||1)));render();});
    render();

    const file=form.querySelector('input[type="file"][name*="Logo or artwork"]');
    if(file){
      const status=document.createElement('span');
      status.className='nfc-upload-status';
      status.setAttribute('aria-live','polite');
      status.textContent='No artwork file selected';
      file.insertAdjacentElement('afterend',status);
      file.addEventListener('change',()=>{status.textContent=file.files?.[0]?`Selected: ${file.files[0].name}`:'No artwork file selected';});
    }
  }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',start):start();
})();